// GDPR consent for the team leave calendar. Wording is fixed by HR/Marcel; the
// tick lives in My Account (both looks) and on HR's employee editor.
export const TEAM_CALENDAR_CONSENT_TEXT =
  'I agree that my absences are visible to my colleagues in the team calendar. ' +
  'Only "absent" is shown, no reason or type of leave. This consent is voluntary ' +
  'and I can withdraw it at any time in my profile or via HR. Not giving or ' +
  'withdrawing consent has no disadvantages for me.';
